import React from "react";
import ConfirmationPopup from "../ConfirmationPopup/ConfirmationPopup";

interface DeactivateConfirmationPopupProps {
    visible: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

const DeactivateConfirmationPopup: React.FC<DeactivateConfirmationPopupProps> = ({
    visible, onConfirm, onCancel,
}) => {
    return (
        <ConfirmationPopup
            visible={visible}
            onCancel={onCancel}
            onConfirm={onConfirm}
            message="Are you sure you want to deactivate this item?"
            confirmButtonText="Deactivate"
            variant="cancel"
        />
    );
};

export default DeactivateConfirmationPopup;
